<template>
    <div class="cv">
        <h1>Mon CV</h1>
        
        <div class="cv-container">
            <div class="cv-actions">
                <a href="/cv/cv_robin_cornut.pdf" target="_blank" class="view-btn">
                    <i class="fas fa-external-link-alt"></i>
                    Voir en plein écran
                </a>
                <a href="/cv/cv_robin_cornut.pdf" download class="download-btn">
                    <i class="fas fa-download"></i>
                    Télécharger
                </a>
            </div>

            <div class="cv-preview">
                <iframe 
                    src="/cv/cv_robin_cornut.pdf" 
                    width="100%" 
                    height="1500px"
                    title="Aperçu du CV"
                ></iframe>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CurriculumPage'
}
</script>

<style scoped>
.cv {
    color: white;
    max-width: 1200px;
    margin: 0 auto;
    padding: 2rem;
}

h1 {
    text-align: center;
    color: #2196F3;
    margin-bottom: 2rem;
    font-size: 2.5rem;
}

.cv-container {
    background: rgba(0, 0, 0, 0.7);
    border: 1px solid #2196F3;
    border-radius: 10px;
    padding: 1.5rem;
    backdrop-filter: blur(5px);
}

.cv-actions {
    margin-bottom: 1.5rem;
    display: flex;
    gap: 1rem;
    justify-content: flex-end;
}

.download-btn, .view-btn {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.8rem 1.5rem;
    border-radius: 5px;
    text-decoration: none;
    transition: all 0.3s ease;
    font-weight: 500;
}

.download-btn {
    background: #2196F3;
    color: white;
}

.view-btn {
    background: rgba(33, 150, 243, 0.1);
    color: #64B5F6;
    border: 1px solid #2196F3;
}

.download-btn:hover, .view-btn:hover {
    transform: translateY(-2px);
}

.download-btn:hover {
    background: #64B5F6;
}

.view-btn:hover {
    background: rgba(33, 150, 243, 0.2);
    border-color: #64B5F6;
}

.cv-preview {
    background: white;
    border-radius: 5px;
    overflow: hidden;
}

.cv-preview iframe {
    border: none;
}

@media (max-width: 768px) {
    .cv {
        padding: 1rem;
    }

    .cv-actions {
        flex-direction: column;
        align-items: stretch;
    }

    .download-btn, .view-btn {
        justify-content: center;
    }

    .cv-preview iframe {
        height: 800px;
    }
}
</style> 